import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { SedeProvider } from "@/lib/sede";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ospiti from "@/pages/Ospiti";
import OspiteDettaglio from "@/pages/OspiteDettaglio";
import Terapie from "@/pages/Terapie";
import DiarioClinico from "@/pages/DiarioClinico";
import EventiAvversi from "@/pages/EventiAvversi";
import Moduli from "@/pages/Moduli";
import RegistrazioneLetto from "@/pages/RegistrazioneLetto";
import AnagraficheDaCompletare from "@/pages/AnagraficheDaCompletare";
import ScorteValorizza from "@/pages/ScorteValorizza";
import Report from "@/pages/Report";
import Utenti from "@/pages/Utenti";
import Preventivi from "@/pages/Preventivi";
import OrdiniFarmaci from "@/pages/OrdiniFarmaci";
import ConsegnaTurno from "@/pages/ConsegnaTurno";
import Appuntamenti from "@/pages/Appuntamenti";
import ContrattoPreventivo from "@/pages/ContrattoPreventivo";
import Impostazioni from "@/pages/Impostazioni";
import PortaleFamiglie from "@/pages/PortaleFamiglie";
import CsvManager from "@/pages/CsvManager";
import MMG from "@/pages/MMG";
import SomministrazioniTurno from "@/pages/SomministrazioniTurno";
import Laboratorio from "@/pages/Laboratorio";
import Scadenze from "@/pages/Scadenze";
import ScaleAlert from "@/pages/ScaleAlert";
import GiroScale from "@/pages/GiroScale";
import GiroDiario from "@/pages/GiroDiario";
import CruscottoQualita from "@/pages/CruscottoQualita";
import DocumentiDaSmistare from "@/pages/DocumentiDaSmistare";
import ControlloAIFA from "@/pages/ControlloAIFA";
import CruscottoDirezionale from "@/pages/CruscottoDirezionale";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="ospiti" element={<Ospiti />} />
        <Route path="ospiti/:id" element={<OspiteDettaglio />} />
        <Route path="terapie" element={<Terapie />} />
        <Route path="diario" element={<DiarioClinico />} />
        <Route path="eventi" element={<EventiAvversi />} />
        <Route path="report" element={<Report />} />
        <Route path="utenti" element={<Utenti />} />
        <Route path="preventivi" element={<Preventivi />} />
        <Route path="lista-attesa" element={<Navigate to="/preventivi" replace />} />
        <Route path="ordini-farmaci" element={<OrdiniFarmaci />} />
        <Route path="consegna-turno" element={<ConsegnaTurno />} />
        <Route path="scadenze" element={<Scadenze />} />
        <Route path="laboratorio" element={<Laboratorio />} />
        <Route path="appuntamenti" element={<Appuntamenti />} />
        <Route path="preventivi/contratto/:prevId" element={<ContrattoPreventivo />} />
        <Route path="impostazioni" element={<Impostazioni />} />
        <Route path="csv" element={<CsvManager />} />
        <Route path="mmg" element={<MMG />} />
        <Route path="somministrazioni" element={<SomministrazioniTurno />} />
        <Route path="moduli" element={<Moduli />} />
        <Route path="m/ospite/:id" element={<RegistrazioneLetto />} />
        <Route path="anagrafiche-da-completare" element={<AnagraficheDaCompletare />} />
        <Route path="scorte-valorizza" element={<ScorteValorizza />} />
        <Route path="scale-alert" element={<ScaleAlert />} />
        <Route path="giro-scale" element={<GiroScale />} />
        <Route path="giro-diario" element={<GiroDiario />} />
        <Route path="qualita" element={<CruscottoQualita />} />
        <Route path="smistamento" element={<DocumentiDaSmistare />} />
        <Route path="controllo-aifa" element={<ControlloAIFA />} />
        <Route path="direzione" element={<CruscottoDirezionale />} />
      </Route>
      <Route path="/famiglia" element={<PortaleFamiglie />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SedeProvider>
          <AppRoutes />
        </SedeProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
